import { LayoutComponents } from "@jelly/lesson";
import variables from "../../../../../../../assets/styles/sass-resources.scss";

import config from "appConfig";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 5,
        rows: 3,
        rowsSize: [6, 1, 1],
        colsSize: [1.16, 1, 1.01, 1, 1],
        colSpan: {
          "0:1": 4,
        },
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "Load bearing 140 mm cross-laminated timber blanket; 30 mm concrete; 30 mm glass wool; 20 mm gypsum fibreboard as screed</br></br>Total thickness: 22 cm</br></br>Rw = 59 dB",
                    formatter: "html",
                    scrollbars: false,
                    styles: {
                      color: variables["text-secondary"],
                      fontSize: "14px",
                      lineHeight: "18px",
                      fontWeight: 400,
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  paddingTop: "50%",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/19/principle/clt-floor.svg`,
                  },
                },
                styles: {
                  padding: "2%",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Original sound",
                    scrollbars: false,
                  },
                },
                styles: {
                  justifyContent: "flex-start",
                  fontSize: "14px",
                  fontWeight: 700,
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "male voice",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/19/principle/original-male-voice.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "female voice",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/19/principle/original-female-voice.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "baby crying",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/19/principle/original-baby-crying.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "party",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/19/principle/original-party.wav`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Sound through the floor",
                    scrollbars: false,
                  },
                },
                styles: {
                  justifyContent: "flex-start",
                  fontSize: "14px",
                  fontWeight: 700,
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "male voice",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/19/principle/clt-male-voice.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "female voice",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/19/principle/clt-female-voice.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "baby crying",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/19/principle/clt-baby-crying.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "party",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/19/principle/clt-party.wav`,
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
